import apiClient from "api-client";

import getWrappedUseMutation from "../../helpers/getWrappedUseMutation";

export const useUpdateForumAttendeeSessionMeetingLocationsMutation = getWrappedUseMutation(
  apiClient.ForumAttendeeSessionMeetingLocation.put,
);
